module.exports = __webpack_public_path__ + "img/29-crossing-over-the-energy.a5f76864.png";